
const   Rerouting = () =>{
    return (
        <>
            <div className="text-center mb-4 mt-4 w_sm_100 mx-auto">
                <h5>Rerouting(إعادة التوجيه)...</h5>
            </div>
        </>
    )
}

export default Rerouting